function createRunElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function createState(message, error = '', retryAction = '') {
  const root = createRunElement('div', 'aichat-artifact-empty', message);
  if (error) root.append(document.createTextNode(`：${error}`));
  if (retryAction) {
    const retry = createRunElement('button', '', '重新加载任务');
    retry.type = 'button';
    retry.dataset.action = retryAction;
    root.append(retry);
  }
  return root;
}

const STATUS_CLASSES = new Set(['queued', 'running', 'completed', 'fallback', 'failed', 'cancelled']);

export function renderRunList(root, { runs = [], loading = false, error = '', getStatusLabel, formatTime } = {}) {
  if (!root) return;
  if (loading) return void root.replaceChildren(createState('正在加载任务中心…'));
  if (error) return void root.replaceChildren(createState('任务加载失败', error, 'retry-load-runs'));
  if (!runs.length) return void root.replaceChildren(createState('当前会话还没有 Agent 任务。发送消息后，任务状态会在这里持续更新。'));
  root.replaceChildren(...runs.map((run) => {
    const status = String(run.status || '').toLowerCase();
    const card = createRunElement('article', `aichat-run-card aichat-run-card--${STATUS_CLASSES.has(status) ? status : 'unknown'}`);
    const head = createRunElement('div', 'aichat-run-card-head');
    head.append(createRunElement('strong', '', run.title || 'Agent 任务'), createRunElement('span', '', getStatusLabel(run.status)));
    const phase = run.status === 'QUEUED' ? '等待系统执行名额' : run.status === 'RUNNING' ? (run.phase ? `当前阶段：${run.phase}` : '等待任务状态') : '任务已结束，可回顾素材与最终回复';
    const detail = `${phase}${run.status === 'RUNNING' && run.currentRound != null ? ` · 第 ${run.currentRound} 轮` : ''}`;
    const time = `${formatTime(run.updatedAt || run.startedAt)}${run.errorMessage ? ` · ${run.errorMessage}` : ''}`;
    card.append(head, createRunElement('p', '', detail), createRunElement('small', '', time));
    return card;
  }));
}
